import { Component } from '@angular/core';

@Component({
  selector: 'app-ed-prep-reports',
  templateUrl: './ed-prep-reports.component.html',
  styleUrls: ['./ed-prep-reports.component.scss']
})
export class EdPrepReportsComponent {

}
